(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.esg.view
  (:require
   [clojure.set :as set]
   [clojure.string :as string]
   [common.localization :as loc]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.property.style :as style]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [herb.core :as h]
   [ui.dom-globals :as dg]))


(defn energy-bar
  [energy-class at-acquisition target]
  [:li
   {:class (h/<class style/energy-performance-certificate-item)}
   [:img
    {:class (h/<class style/energy-bar energy-class)
     :src   (str "https://static.zapflow.com/images/logos/EPC_" energy-class ".png")}]
   [:div
    {:class (h/<class style/energy-labels)}
    (when (= energy-class target)
      [:div
       {:class (h/<class style/energy-label (= energy-class at-acquisition))}
       "Target during holding period"])
    (when (= energy-class at-acquisition)
      [:div
       {:class (h/<class style/energy-label (= energy-class target))}
       "Acquisition status"])]])

(defn green-icon
  [green-building-certifications-set certification
   {:keys [edit-mode? save-text]}]
  (let [selected? (boolean (get green-building-certifications-set certification))]
    (when (or edit-mode?
              selected?)
      [:div
       {:class (h/<class style/select-row)}
       (when edit-mode?
         [:input
          {:type      "checkbox"
           :on-change (fn []
                        (save-text [:green-building-certification]
                                   (->> (if selected?
                                          (set/difference green-building-certifications-set #{certification})
                                          (set/union green-building-certifications-set #{certification}))
                                        (string/join ";"))))
           :value     (if selected?
                        "on"
                        "")
           :checked   selected?}])
       [:img
        {:class    (h/<class style/certification-logo selected?)
         :on-click (fn []
                     (save-text [:green-building-certification]
                                (->> (if selected?
                                       (set/difference green-building-certifications-set #{certification})
                                       (set/union green-building-certifications-set #{certification}))
                                     (string/join ";"))))
         :src      (case certification
                     "breeam"
                     "/img/esg/BREEAM_logo.svg"
                     "dgnb"
                     "/img/esg/dgnb.jpg"
                     "usgbc"
                     "/img/esg/U.S._Green_Building_Council_logo.svg")}]])))


(defn esg-section
  [{:keys [holding-name
           energy-performance-certificate-at-acquisition energy-performance-certificate-target energy-performance-status
           green-building-certification green-building-status
           eu-taxonomy-plan eu-taxonomy-alignment other-esg-development]}
   {:keys [edit-mode? save-text] :as props}]
  (let [green-building-certifications-set (-> green-building-certification
                                              (string/split #";")
                                              (set))]
    [section
     (str holding-name " - Sustainability")
     nil
     [:div
      [card
       {:title ""}
       [grid/row {}
        [grid/column {:span 4}
         [:<>
          [:h3
           {:class (h/<class style/h3)}
           "Energy Performance Certificate (energy class)"]
          (when edit-mode?
            [:<>
             [:div
              {:class (h/<class style/select-row)}
              [:label
               {:class (h/<class style/select-label)}
               (loc/tr :energy-performance-certificate-at-acquisition)
               [:select
                {:class     (h/<class style/select)
                 :value     energy-performance-certificate-at-acquisition
                 :on-change (fn [e]
                              (let [value (dg/event-target-value e)]
                                (save-text [:energy-performance-certificate-at-acquisition] value)))}
                [:option {:value "" :label ""}]
                [:option {:value "A" :label "A"}]
                [:option {:value "B" :label "B"}]
                [:option {:value "C" :label "C"}]
                [:option {:value "D" :label "D"}]
                [:option {:value "E" :label "E"}]
                [:option {:value "F" :label "F"}]
                [:option {:value "G" :label "G"}]]]
              [:label
               {:class (h/<class style/select-label)}
               (loc/tr :energy-performance-certificate-target)
               [:select
                {:class     (h/<class style/select)
                 :value     energy-performance-certificate-target
                 :on-change (fn [e]
                              (let [value (dg/event-target-value e)]
                                (save-text [:energy-performance-certificate-target] value)))}
                [:option {:value "" :label ""}]
                [:option {:value "A" :label "A"}]
                [:option {:value "B" :label "B"}]
                [:option {:value "C" :label "C"}]
                [:option {:value "D" :label "D"}]
                [:option {:value "E" :label "E"}]
                [:option {:value "F" :label "F"}]
                [:option {:value "G" :label "G"}]]]]])
          [:ul
           {:class (h/<class style/energy-performance-certificate-list)}
           [energy-bar "A" energy-performance-certificate-at-acquisition energy-performance-certificate-target]
           [energy-bar "B" energy-performance-certificate-at-acquisition energy-performance-certificate-target]
           [energy-bar "C" energy-performance-certificate-at-acquisition energy-performance-certificate-target]
           [energy-bar "D" energy-performance-certificate-at-acquisition energy-performance-certificate-target]
           [energy-bar "E" energy-performance-certificate-at-acquisition energy-performance-certificate-target]
           [energy-bar "F" energy-performance-certificate-at-acquisition energy-performance-certificate-target]
           [energy-bar "G" energy-performance-certificate-at-acquisition energy-performance-certificate-target]]
          [free-text-card/free-text-section "Status now" energy-performance-status props]]]
        [grid/column {:span 4}
         [:<>
          [:h3
           {:class (h/<class style/h3)}
           "Green building certification"]
          [:div
           {:class (h/<class style/energy-performance-certificate-list)}
           [green-icon green-building-certifications-set "breeam" props]
           [green-icon green-building-certifications-set "usgbc" props]
           [green-icon green-building-certifications-set "dgnb" props]]
          [free-text-card/free-text-section "Target and status now" green-building-status props]]]
        [grid/column {:span 4}
         [:<>
          [:h3
           {:class (h/<class style/h3)}
           "EU Taxonomy"]
          (if edit-mode?
            [:div
             {:class (h/<class style/select-row)}
             [:select
              {:class     (h/<class style/select-wide)
               :value     eu-taxonomy-alignment
               :on-change (fn [e]
                            (save-text [:eu-taxonomy-alignment] (dg/event-target-value e)))}
              [:option {:value "" :label ""}]
              [:option {:value "Aligned" :label "Aligned"}]
              [:option {:value "Not aligned" :label "Not aligned"}]]]
            [:div
             {:class (h/<class style/text-value)}
             (str eu-taxonomy-alignment)])
          (when (= "Not aligned" eu-taxonomy-alignment)
            [free-text-card/free-text-section "Plan to be aligned" eu-taxonomy-plan props])
          [free-text-card/free-text-section "Other sustainability developments" other-esg-development props]]]]]]]))

(defn epc-row
  [{:keys [energy-performance-counts]}
   {:keys [edit-mode? save-text]}
   epc-category]
  [:tr
   [:td
    {:class (h/<class style/td)}
    epc-category]
   [:td
    {:class (h/<class style/td)}
    (if edit-mode?
      [:input
       {:value     (get energy-performance-counts epc-category "")
        :class     (h/<class style/input)
        :on-change (fn [e]
                     (save-text [:energy-performance-counts]
                                (pr-str (merge {}
                                               energy-performance-counts
                                               {epc-category (dg/event-target-value e)}))))}]
      [:span
       {:class (h/<class style/text-value)}
       (get energy-performance-counts epc-category "")])]])

(defn epc-table
  [ui-data props]
  [:table
   {:class (h/<class style/table)}
   [:thead
    [:tr
     [:th
      {:class (h/<class style/th)}
      "EPC"]
     [:th
      {:class (h/<class style/th)}
      "Number of properties"]]]
   [:tbody
    [epc-row ui-data props "EPC A"]
    [epc-row ui-data props "EPC B"]
    [epc-row ui-data props "EPC C"]
    [epc-row ui-data props "EPC D"]
    [epc-row ui-data props "EPC E"]
    [epc-row ui-data props "EPC F"]
    [epc-row ui-data props "EPC G"]
    [epc-row ui-data props "No EPC"]]])

(defn green-building-certification-table
  [{:keys [green-building-certification-sqm-pct
           green-building-certification-certified-count
           green-building-certification-total-count]}
   {:keys [edit-mode? save-text]}]
  [:table
   {:class (h/<class style/table)}
   [:thead
    [:tr
     [:th
      {:class    (h/<class style/th)
       :col-span 2}
      "Share of certified properties"]]]
   [:tbody
    [:tr
     [:td
      {:class (h/<class style/td)}
      "Certified sqm %"]
     [:td
      {:class (h/<class style/td)}
      (if edit-mode?
        [:input
         {:value     (or green-building-certification-sqm-pct "")
          :class     (h/<class style/input)
          :on-change (fn [e]
                       (save-text [:green-building-certification-sqm-pct] (dg/event-target-value e)))}]
        [:span
         {:class (h/<class style/text-value)}
         (or green-building-certification-sqm-pct "")])]]
    [:tr
     [:td
      {:class (h/<class style/td)}
      "Certified number of properties"]
     [:td
      {:class (h/<class style/td)}
      (if edit-mode?
        [:span
         {:class (h/<class style/row)}
         [:input
          {:value     (or green-building-certification-certified-count "")
           :class     (h/<class style/input)
           :on-change (fn [e]
                        (save-text [:green-building-certification-certified-count] (dg/event-target-value e)))}]
         "/"
         [:input
          {:value     (or green-building-certification-total-count "")
           :class     (h/<class style/input)
           :on-change (fn [e]
                        (save-text [:green-building-certification-total-count] (dg/event-target-value e)))}]]
        [:span
         {:class (h/<class style/text-value)}
         (str green-building-certification-certified-count "/" green-building-certification-total-count)])]]]])


(defn portfolio-esg-section
  [{:keys [holding-name energy-performance-status green-building-status
           eu-taxonomy-plan eu-taxonomy-notes eu-taxonomy-alignment other-esg-development]
    :as   ui-data}
   {:keys [edit-mode? save-text] :as props}]
  (let []
    [section
     (str holding-name " - Sustainability")
     nil
     [:div
      [card
       {:title ""}
       [grid/row {}
        [grid/column {:span 4}
         [:<>
          [:h3
           {:class (h/<class style/h3)}
           "Energy Performance Certificate (energy class)"]
          [epc-table ui-data props]
          [free-text-card/free-text-section "Notes" energy-performance-status props]]]
        [grid/column {:span 4}
         [:<>
          [:h3
           {:class (h/<class style/h3)}
           "Green building certification"]
          [green-building-certification-table ui-data props]
          [free-text-card/free-text-section "Target and status now" green-building-status props]]]
        [grid/column {:span 4}
         [:<>
          [:h3
           {:class (h/<class style/h3)}
           "EU Taxonomy alignment"]
          (if edit-mode?
            [:div
             {:class (h/<class style/select-row)}
             [:select
              {:class     (h/<class style/select-wide)
               :value     eu-taxonomy-alignment
               :on-change (fn [e]
                            (save-text [:eu-taxonomy-alignment] (dg/event-target-value e)))}
              [:option {:value "" :label ""}]
              [:option {:value "Aligned" :label "Aligned"}]
              [:option {:value "Not aligned" :label "Not aligned"}]]]
            [:div
             {:class (h/<class style/text-value)}
             (str eu-taxonomy-alignment)])
          (when (= "Not aligned" eu-taxonomy-alignment)
            [free-text-card/free-text-section "Plan to be aligned" eu-taxonomy-plan props])
          [free-text-card/free-text-section "Notes" eu-taxonomy-notes props]
          [:h3
           {:class (h/<class style/h3)}
           "Other sustainability initiatives/improvements"]
          [free-text-card/free-text-section "Target and status now" other-esg-development props]]]]]]]))
